import { render, staticRenderFns } from "./ConfirmationProcessing.vue?vue&type=template&id=d2922e98"
import script from "./ConfirmationProcessing.vue?vue&type=script&lang=ts"
export * from "./ConfirmationProcessing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports